export default {
	updateDialog: {
		updated: 'A new version has been loaded.',
	},
}
